import { getChainInfo, getChainName } from '@ui/constants/chain';
import { ChainId, ChainName } from '@ui/types/chain';

export function getExplorerLink(
  data: string,
  type: 'transaction' | 'token' | 'address' | 'block' | 'countdown' | 'tokens' | 'stake-portfolio',
  chainId: ChainId,
): string {
  const chainParameter = getChainInfo(chainId);
  const explorer = chainParameter.explorer;
  // const chainName = getChainName(chainId);

  switch (type) {
    case 'transaction': {
      return `${explorer}/tx/${data}`;
    }
    case 'token': {
      return `${explorer}/token/${data}`;
    }
    case 'block': {
      return `${explorer}/block/${data}`;
    }
    case 'tokens': {
      return `${explorer}/address/${data}#tokens`;
    }
    case 'stake-portfolio': {
      return `${explorer}/address/${data}?portfolio=Stake`;
    }
    default: {
      return `${explorer}/address/${data}`;
    }
  }
}
